/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyertitle2Inputs */

const en_checkinflyertitle2 = /** @type {(inputs: Checkinflyertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live Room flyer`)
};

const de_checkinflyertitle2 = /** @type {(inputs: Checkinflyertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer für den Live Room`)
};

/**
* | output |
* | --- |
* | "Live Room flyer" |
*
* @param {Checkinflyertitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyertitle2 = /** @type {((inputs?: Checkinflyertitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyertitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyertitle2(inputs)
	return de_checkinflyertitle2(inputs)
});
export { checkinflyertitle2 as "checkinFlyerTitle" }